// import { useAppStore } from '@/store/app';

const selectedProduct = () => {
  // const appStore = useAppStore();

  if (localStorage?.selectedProduct) {
    // const selectedProduct = JSON.parse(localStorage?.selectedProduct) ?? '';
    // appStore.setSelectedProduct({ productName: selectedProduct });
  }
};

export default selectedProduct;
